import { CommitAction } from '@/enum/CommitAction'
import { AlsBase, getDefaultAlsBase } from './AlsBase'


export interface AlsUser extends AlsBase {    
    usrEmail: string    
}

export const getDefaultAlsUser = (commit:CommitAction=CommitAction.listAndDic):AlsUser => {     
    return {
        ...getDefaultAlsBase(commit),
        usrEmail:''
    }
}

export const cleanAlsUser = (filter:AlsUser) => {
    if(!filter) return    
    if(!filter.id) delete filter.id
}
